import 'bootstrap';
import 'owl.carousel';
import * as Stickyfill from 'stickyfilljs';
import '@babel/polyfill';

import Media from './media';
import Menu from './menu';

const $ = window.jQuery;
const { themeOptions } = window;

// Theme options are available in the global object {themeOptions}
class Jello {
  run() {
    this.Media = new Media();

    Jello.setStickyFills();
    this.responsive();
  }

  responsive() {
    if (!this.Media.large) {
      Menu.moveMetaToMain();
    }
  }

  static createSlider(el, options) {
    Object.assign(options, {
      navText: [
        themeOptions.slider_navigation_left ? themeOptions.slider_navigation_left : '<i class="fas fa-angle-left fa-2x">',
        themeOptions.slider_navigation_right ? themeOptions.slider_navigation_right : '<i class="fas fa-angle-right fa-2x">',
      ],
    });
    
    $(el).owlCarousel(options);
  }

  static setStickyFills() {
    const stickyClasses = [
      'sticky',
      'sticky-xs',
      'sticky-sm',
      'sticky-md',
      'sticky-lg',
      'sticky-xl',
    ];

    stickyClasses.forEach((className) => {
      const sticky = $(`.${className}`);
      if (sticky.length) {
        Stickyfill.addOne(sticky);
      }
    });
  }
}

$(document).ready(() => {
  const jello = new Jello();
  global.Jello = Jello;
  jello.run();
});
